<template>
  <div class="nameConfiguration_dialog">
    <el-dialog width="450px" :close-on-click-modal="false" :title="title" @close="close" :visible.sync="dialogVisible" v-loading="loading">
      <el-form :model="ruleForm" label-width="100px" ref="ruleForm">
        <el-form-item
          label="区划名称"
          :rules="{ required: true, message: '区划名称不能为空', trigger: 'change'}"
          prop="qhdm"
        >
          <!--县乡村 联动-->
          <el-cascader
            class="textInput"
            v-model="ruleForm.qhdm"
            ref="qhdm"
            @change="liandong"
            :options="areaOptions"
            :props="areaProps"
            :show-all-levels="false"
            placeholder="请选择区划"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="机构名称" prop="departmentNumber"
          :rules="{ required: true, message: '机构名称不能为空', trigger: 'change'}">
          <el-select ref="workList" v-model="ruleForm.departmentNumber" filterable>
            <el-option
              v-for="item in workList"
              :key="item.number"
              :label="item.name"
              :value="item.number">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台名称" prop="name"  :rules="{ required: true, message: '平台名称不能为空', trigger: 'change'}">
           <el-input
              class="textInput"
              v-model="ruleForm.name"
              placeholder="请输入平台名称"
            ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" plain @click="close">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandler">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import API from "../../../../api/configuration/api_configuration"
  import API_dic from "@/api/api_common";
  import Cookies from 'js-cookie'
  export default {
    created(){
      this.GLOBAL.eventBus.$on("show_colorate_dialog",this.show)
      this.getNextXzqData();
      this.GLOBAL.eventBus.$on("areaOptionsCompleted",this.getNextXzqData);
    },
    mounted(){
      this.getDicList()
    },
    data(){
      return {
        dialogVisible: false,
        loading: false,
        title:"平台名称",
        areaValue: "",
        update:false,
        areaCode: Cookies.get('curAreaCode'),
        areaName: Cookies.get('curAreaName'),
        qhdm: Cookies.get('curAreaCode'),
        qhmc: Cookies.get('curAreaName'),
        ruleForm: {
          qhdm: "",
          departmentNumber:"",
          name:""
        },
        materialList:[],
        workList:[],
        PTname:[],
        childWorkList:[],
        dialogFormVerify:[],
        areaOptions: [],
        areaProps: {
          label: 'qhmc',
          value: 'qhdm',
          children: 'children',
          checkStrictly: true,
          lazy: true,
          lazyLoad (node, resolve) {
            setTimeout(() => {
              let nodes;
              if(node.children.length>0){
                nodes = []
                resolve(nodes);
              }else{
                API_dic.getSubArea({qhdm: node.value}).then(res=>{
                  nodes = res.data
                  // if(node.value.length==6){
                    nodes.forEach(item=>{
                      if(item.qhdm.length==6){
                        item.leaf = true
                      }
                    })
                  // }
                  resolve(nodes);
                })
              }
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              // resolve(nodes);
            }, 300);
          }
        },
      }
    },
    methods:{
      show(obj){
        // 地区代码与主页面的查询条件保持一致
          this.dialogVisible = true;
          if(obj){
            this.title = "编辑";
            this.ruleForm.id= obj.id
            this.ruleForm.qhdm= obj.qhdm
            this.ruleForm.departmentName=obj.departmentName
            if(obj.departmentNumber){
               this.ruleForm.departmentNumber= obj.departmentNumber
            }
            if(obj.name){
              this.ruleForm.name= obj.name
              this.$nextTick(()=>{
                if(this.$refs.qhdm){
                  this.$refs.qhdm.inputValue = obj.qhmc;
                }
              })
            }else{
              this.getSysName(obj.qhdm)
            }
            this.update = true;
          }else{
            this.title = "新增";
            this.update = false;
            this.qhdm = this.areaCode;
            this.ruleForm.qhdm = "";
            this.ruleForm.qhmc = "";
            if(this.$refs.qhdm){
              this.$refs.qhdm.inputValue = ""
            }
            this.ruleForm.departmentNumber='--';
            this.ruleForm.name='';
          }
      },
      getDicList(){
        let that = this;
        const params = {qhdm: this.areaCode};
        API.dicApplicationCheck(params).then(res => {
          if(res.code === 0 && res.data){
              that.workList = res.data.list;
               that.workList.unshift({name:'--',number:'--'})
            that.ruleForm.departmentNumber=that.workList[0].number
            this.$forceUpdate()
          }
        }).catch(err=>{
          that.GLOBAL.warning(err.msg || "获取服务环节数据失败!");
        })
      },
      getSysName(qhdm){
        let that = this;
        API.applicationDicDetail({qhdm:qhdm}).then(res => {
          if(res.code === 0 ){
              this.ruleForm.name = res.data.detail.name;
          }
        }).catch(err=>{
          that.GLOBAL.warning(err.msg || "获取服务环节数据失败!");
        })
      },
      workListChange(){
        let that = this;
        // const number = this.ruleForm.dicNumber;
        // const name = this.workList.filter(item=>{
        //   return item.dicNumber === number
        // })[0].dicName;
        const params = {qhdm: this.areaCode};
        API.getChildWorkList(params).then(res => {
          if(res.code === 0 && res.data){
              that.childWorkList = res.data.list;
          }
        }).catch(err=>{
          that.GLOBAL.warning(err.msg || "获取服务环节数据失败!");
        })
      },
      submitForm(){
        let that = this;
        let params = {
          qhdm: that.qhdm,
          qhmc:that.$refs.qhdm.inputValue,
          name:that.ruleForm.name,
          departmentNumber:that.ruleForm.departmentNumber,
          appId: process.env.appId,
        }
         if(params.departmentNumber=='--'){
          params.departmentNumber = ''
        }
        that.qhdm = Cookies.get('curAreaCode');
        API.dicApplicationSave(params).then(res=>{
          if(res.code === 0){
            that.GLOBAL.success(res.msg);
            that.GLOBAL.eventBus.$emit("refreshColorateList");
            that.close();
            this.$emit('dicApplicationUpdate','true')
          }else{
            that.GLOBAL.success(res.msg);
          }
        }).catch(err=>{
          that.GLOBAL.warning(err.msg || "添加失败!");
        })
      },
       dicApplicationUpdate(){
        let that = this;

        let params = {
          id:that.ruleForm.id,
          qhdm: that.qhdm,
          qhmc:that.$refs.qhdm.inputValue,
          name:that.ruleForm.name,
          departmentNumber:that.ruleForm.departmentNumber,
        }
         if(params.departmentNumber=='--'){
          params.departmentNumber = ''
        }
        that.qhdm = Cookies.get('curAreaCode');
        API.dicApplicationUpdate(params).then(res=>{
          if(res.code === 0){
            that.GLOBAL.success(res.msg);
            that.GLOBAL.eventBus.$emit("refreshColorateList");
            that.close();
            this.$emit('dicApplicationUpdate','true')
          }
        }).catch(err=>{
          that.GLOBAL.warning(err.msg || "添加失败!");
        })
      },
      submitHandler(){
        // debugger
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if(this.update==true){
                this.dicApplicationUpdate()
            }else{
              this.submitForm()
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      close(){
        this.$refs["ruleForm"].resetFields();
        this.qhdm = this.areaCode;
        this.ruleForm.qhdm = "";
        this.$refs.qhdm.inputValue = ""
        this.ruleForm.departmentNumber=''
        this.ruleForm.name=''
        this.dialogVisible=false;
      },
      /*获取查询条件数据*/
      async getNextXzqData(){
        if (this.areaCode) {
          this.areaOptions = [{
            qhdm: this.areaCode,
            qhmc: this.areaCode==1?'全国':this.areaName,
            children: null,
            leaf: this.areaCode.length>=6
          }]
        }else{
          this.areaOptions = []
        }
      },
      liandong :function (obj) {
        this.qhdm = obj[obj.length - 1]
        // this.ruleForm.qhdm = this.qhdm;
      },
    }
  }
</script>

<style lang="less">
.nameConfiguration_dialog{
  .textInput,
  .el-input {
    width: 250px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/studio/systemConfig/nameConfiguration/popup/colocate-popup.vue